// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__XB2RG","assignButton":"CreateEditEquipmentSchedule_assignButton__1OOF_"};